/**
 * Характеристики из текста описания.
 * В импортированном каталоге структурированных характеристик нет: параметры
 * записаны строками «• Параметр: значение». Показываем их таблицей, как в
 * фирменном каталоге. Та же логика используется AI-консультантом в боте.
 */
export type SpecItem = { label: string; value: string };

export function specsFromDescription(description: string | null | undefined, limit = 40): SpecItem[] {
  const out: SpecItem[] = [];
  const seen = new Set<string>();
  for (const raw of (description ?? '').split(/\r?\n/)) {
    const line = raw.replace(/^[\s•·\-–—*▪►✓✔]+/, '').trim();
    const m = /^([^:：]{2,45})[:：]\s*(.{1,200})$/.exec(line);
    if (!m) continue;
    const label = (m[1] ?? '').trim().replace(/\s+/g, ' ');
    const value = (m[2] ?? '').trim().replace(/\s+/g, ' ');
    if (!value || label.split(/\s+/).length > 5 || /https?$/i.test(label) || /[.!?]/.test(label)) continue;
    const key = (label + '|' + value).toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ label, value });
    if (out.length >= limit) break;
  }
  return out;
}
